import $ from 'jquery';

/*
 * Issue #296: brand colours for the MI estimator.
 *
 * The calculator bundle (main.css) only ever compiles CMG's palette, so a plain SCSS variable would paint CMG teal
 * and green on every JV site. The brand sheet (loaded after main.css) is what actually carries each brand's
 * `.button-deep-see` (secondary) and `.button-primary` (primary) colours, so this reads them back from throwaway
 * probes carrying those classes and publishes them as --mi-secondary / --mi-primary on the element. The SCSS
 * derives every accent and tint from those two custom properties, with CMG's values as the fallback.
 */
export default function applyBrandTheme(el) {
    if (!el || !window.getComputedStyle) return;

    const $probes = $('<span style="display:none"><span class="button-cmg button-deep-see" data-probe="secondary"></span>'
        + '<span class="button-cmg button-primary" data-probe="primary"></span></span>').appendTo('body');

    try {
        const secondary = getComputedStyle($probes.find('[data-probe="secondary"]')[0]).color;
        const primary = getComputedStyle($probes.find('[data-probe="primary"]')[0]).backgroundColor;

        if (secondary) el.style.setProperty('--mi-secondary', secondary);
        if (primary && primary !== 'rgba(0, 0, 0, 0)') el.style.setProperty('--mi-primary', primary);
    } finally {
        $probes.remove();
    }
}
